export default __webpack_public_path__ + "static/media/2245.23045f03.svg";